import { render, staticRenderFns } from "./HistoryDrawer.vue?vue&type=template&id=2b85658e&scoped=true"
import script from "./HistoryDrawer.vue?vue&type=script&lang=js"
export * from "./HistoryDrawer.vue?vue&type=script&lang=js"
import style0 from "./HistoryDrawer.vue?vue&type=style&index=0&id=2b85658e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85658e",
  null
  
)

export default component.exports